<template>
  <div class="order-list">
    <div class="order-list-items pa-5">
      <draggable v-model="list" draggable=".item">
        <template v-for="(element, i) in list">
          <div
            v-if="!isFixed(element.id)"
            :key="element.id"
            class="item order-col"
          >
            <div class="order-item d-flex align-center text-truncate" :title="element.name">
              {{ element.name }}
              <v-spacer></v-spacer>
              <v-btn
                icon
                color="red"
                x-small
                v-if="isEmpty(element.id) && isAdmin"
                @click="removeEmpty(i)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
        </template>
      </draggable>
      <template v-for="item in list">
        <div :key="item.id" v-if="isFixed(item.id)" class="item order-col">
          <div class="order-item">{{ item.name }}</div>
        </div>
      </template>
    </div>
    <div v-if="id" class="order-list-footer d-flex pa-4">
      <v-spacer></v-spacer>
      <v-btn
        class="primary mr-3"
        tile
        @click="addEmpty()"
        v-if="isAdmin || isDispatcher || isDataEntryAndDispatcher"
        depressed
        >Add Empty Field</v-btn
      >
      <v-btn class="success" tile @click="submit" v-if="isAdmin || isDispatcher || isDataEntryAndDispatcher" depressed
        >Update Order</v-btn
      >
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { fixed_order } from "../../../assets/js/default";
import { fieldOrders } from "../../../assets/js/firebase";
export default {
  components: {
    draggable
  },
  data() {
    return {
      list: [],
      id: ""
    };
  },
  watch: {
    global() {
      this.init(this.id);
    },
    service() {
      this.init(this.id);
    }
  },
  computed: {
    orders() {
      let item = this.$store.getters.fieldOrders.find(item => {
        return item.id == this.id;
      });
      return item != null ? item : {};
    },
    global() {
      return this.$store.getters.globalFields;
    },
    service() {
      return this.$store.getters.serviceFields.filter(item => {
        return item.services && item.services.indexOf(this.id) != -1;
      });
    }
  },
  methods: {
    isEmpty(id) {
      return id.startsWith("empty-space-");
    },
    addEmpty() {
      this.list.push({
        index: 900,
        id: `empty-space-${new Date().getTime()}`,
        name: "Empty Space"
      });
    },
    removeEmpty(i) {
      this.list.splice(i, 1);
    },
    isFixed(id) {
      return fixed_order[id] != undefined;
    },
    async submit() {
      const vm = this;
      try {
        let doc = {};
        vm.$root.loader = true;
        vm.list.forEach((item, i) => {
          doc[item.id] = i;
        });
        await fieldOrders.doc(vm.id).set(doc);
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    getEmpty(orders) {
      let list = [];
      Object.keys(orders).forEach(id => {
        if (id.startsWith("empty-space-")) {
          list.push({
            name: "Empty Space",
            id,
            index: orders[id]
          });
        }
      });
      return list;
    },
    init(id) {
      const vm = this;
      vm.id = id;
      let { global, service, orders } = vm;
      let list = global.map(item => {
        let index = orders[item.id];
        let id = item.id;
        // if (orders[item.name] != undefined) index = orders[item.name];
        if (vm.isFixed(id)) index = fixed_order[id];
        if (index == undefined) index = 1000;
        return { name: item.name, index, id };
      });
      list = list.concat(
        service.map(item => {
          let index = orders[item.id];
          let id = item.id;
          // if (orders[item.name] != undefined) index = orders[item.name];
          if (vm.isFixed(id)) index = fixed_order[id];
          if (index == undefined) index = 1000;
          return { name: item.name, index, id };
        })
      );
      list = list.concat(vm.getEmpty(orders));
      list = list.sort((a, b) => {
        return a.index - b.index;
      });
      vm.list = list;
    }
  }
};
</script>

<style lang="scss">
.order-list {
  width: 100%;
  height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  &-items {
    overflow-y: scroll;
    flex: 1;
    height: calc(100vh - 200px);
  }
  &-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  }
}
.order-col {
  width: 50%;
  float: left;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
}
.order-item {
  padding: 10px;
  margin: 10px;
  font-size: 14px;
  border-radius: 5px;
  background: #d3d3d382;
}
</style>
